/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, MinusIcon, PlusIcon } from '@common-fe/common-fe';
import styled from 'styled-components';

import theme from '@/styles/theme';

const Wrapper = styled(Box)`
  position: absolute;
  z-index: 1000;
`;

const Button = styled.button`
  background-color: ${({ theme }) => theme.colors.background1};
  ${({ theme }) => theme.fonts.text14Bold}
  border-radius: ${({ theme }) => theme.rounds.button1Round};
  ${({ theme }) => theme.shadows.default};
  padding: 0 ${({ theme }) => theme.spacings.spacing4};
  width: ${({ theme }) => theme.controls.height};
  height: ${({ theme }) => theme.controls.height};
  transition: all 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textAccent};
  ${({ theme }) => theme.border.grey6};
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.buttonPrimary};
    svg {
      fill: ${({ theme }) => theme.colors.textOnColor};
      stroke: ${({ theme }) => theme.colors.textOnColor};
    }
  }
  &:active {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.buttonPrimaryHover};
    svg {
      fill: ${({ theme }) => theme.colors.textOnColor};
    }
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.colors.border1};
    svg {
      fill: ${({ theme }) => theme.colors.textOnColor};
    }
  }
`;

const ZoomButtons = ({ scale, minScale, maxScale, onZoomInClick, onZoomOutClick, isInCenter }: any) => {
  if (isInCenter) {
    return (
      <Wrapper
        data-testid="zoom-button"
        direction="row-reverse"
        gap="spacing4"
        background="background1"
        round="container2Round"
        style={{
          right: '50%',
          bottom: theme.spacings.spacing12 ,
        }}
      >
        <Button onClick={onZoomOutClick} style={{ border: 'none' }} disabled={scale <= minScale}>
          <MinusIcon size="14px" color="iconOnColor" />
        </Button>
        <Button onClick={onZoomInClick} style={{ border: 'none' }} disabled={scale >= maxScale}>
          <PlusIcon size="14px" color="iconOnColor" />
        </Button>
      </Wrapper> 
    );
  }

  return (
    <Wrapper data-testid="zoom-button" gap="spacing4" style={{ right: 0 }}>
      <Button onClick={onZoomInClick} disabled={scale >= maxScale}>
        <PlusIcon size="14px" color="iconOnColor" />
      </Button>
      <Button onClick={onZoomOutClick} disabled={scale <= minScale}>
        <MinusIcon size="14px" color="iconOnColor" />
      </Button>
    </Wrapper>
  );
};

export default ZoomButtons;
